import React from "react";
import { Grid, Card, Box, Skeleton } from "@mui/material";

/**
 * EventsSearchBarSkeleton Component
 *
 * Loading skeleton for the Events search bar
 */
export const EventsSearchBarSkeleton: React.FC = () => {
  return (
    <Box sx={{ mb: 4 }}>
      <Skeleton variant="rounded" height={56} />
    </Box>
  );
};

/**
 * EventsSkeleton Component
 *
 * Loading skeleton for the events grid
 */
const EventsSkeleton: React.FC = () => {
  return (
    <Grid container spacing={3}>
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Card sx={{ borderRadius: 3 }}>
            <Skeleton variant="rectangular" height={200} />
            <Box sx={{ p: 2 }}>
              <Skeleton variant="text" height={32} width="80%" />
              <Skeleton variant="text" height={24} width="60%" />
              <Skeleton variant="text" height={20} />
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default EventsSkeleton;
